<div
  class="task-card"
  (click)="openTask()"
  [ngClass]="{ required: required, deleted: deleted }"
>
  <p class="title">
    {{ task.editedTitle ? task.editedTitle : task.title }}
    <span *ngIf="required">*</span>
  </p>
  <div class="divisor"></div>
  <p class="subtitle">{{ task.description }}</p>
  <mat-icon class="eye" *ngIf="clickable">visibility</mat-icon>
</div>
